<script setup lang="ts">
import InputDebounced from '../input-debounced.vue';
import InputGroup from '../input-group.vue';

const props = defineProps<{
    search?: string;
}>();
const emit = defineEmits<{
    (event: 'update:search', value: string): void;
}>();

</script>
<template>
    <div class="form_row">
        <InputGroup>
            <template #head>
                <i class="bi bi-search" />
            </template>
            <InputDebounced :model-value="props.search" class="form-control" placeholder="Ricerca" @update:model-value="(v) => emit('update:search', v)" />
        </InputGroup>
    </div>
</template>
